// extracted by mini-css-extract-plugin
export default {"page":"wr-z","landingBackground":"xr-z","nonLandingBackground":"yr-z"};